import { gql } from '@apollo/client';
import { graphql } from '@apollo/client/react/hoc';
import { loadMorePaginationProp, SimpleLoadingComponent } from '../../utils/apollo';

import Institutions from './institutions-table';

const query = gql`
  query Viewer($filter: String!, $first: Int, $after: String) {
    viewer {
      queryHighSchools(filter: $filter, first: $first, after: $after) {
        edges {
          node {
            id
            name
            address {
              field_hs_eln_zip
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

const graphqlData = graphql(query, {
  options: ({ filter }) => ({
    variables: {
      first: 5,
      filter,
    },
  }),
  props: loadMorePaginationProp(query),
});

export default SimpleLoadingComponent(
  graphqlData,
)(Institutions);
